import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompanyItem from './companyItem';
import locales from './locales';

const ICON_CARET_RIGHT = 'ri-arrow-right-s-line';

export default class CompanyGroupSelector extends Component {
  static propTypes = {
    authInfo: PropTypes.object.isRequired,
    groupCompanies: PropTypes.array.isRequired,
    lang: PropTypes.string.isRequired,
    myAccountUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleToggleCompanySelector = this.handleToggleCompanySelector.bind(this);
    this.state = { companySelectorOpen: false };
  }

  handleToggleCompanySelector() {
    const { companySelectorOpen } = this.state;
    this.setState({ companySelectorOpen: !companySelectorOpen });
  }

  // Warning: react-onclickoutside use this
  handleClickOutside() {
    this.setState({ companySelectorOpen: false });
  }
  onChangeCompany(id, myAccountUrl) {
    document.location = myAccountUrl + `?company_id=${id}`;
  }

  render() {
    const { lang, groupCompanies, authInfo, myAccountUrl } = this.props;
    const t = locales(lang);
    const groupId = authInfo.getGroupId();
    const { companySelectorOpen } = this.state;

    const itemsGroupCompanies = groupCompanies.map((company, i) => (
      <CompanyItem
        id={company.id}
        groupId={groupId}
        href="#"
        key={company.id}
        onClick={this.handleToggleCompanySelector}
        name={company.name}
        onChangeCompany={id => this.onChangeCompany(id, myAccountUrl)}
      />
    ));

    return (
      <div className="extended__group">
        <label className="label__companies pointer" onClick={this.handleToggleCompanySelector}>
          {t('globalHeader.companies.labelOtherCompanies')}
          <i className={ICON_CARET_RIGHT} />
        </label>

        <div className={`account__dropdown--floating ${companySelectorOpen ? '' : 'hidden'}`}>
          {itemsGroupCompanies}
        </div>
      </div>
    );
  }
}

CompanyGroupSelector.propTypes = {
  authInfo: PropTypes.object.isRequired,
  groupCompanies: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  myAccountUrl: PropTypes.string.isRequired,
};
